import React, {useState} from "react";
import PropTypes from "prop-types";
import {Icon, IconButton, makeStyles, Typography} from "@material-ui/core";

import JsonScreenHoc from "../../../../../../../HocHelpers/JsonScreenHoc";

import ClassificationModal from "./ClassificationModal";
import ClassificationItem from "./ClassificationItem";

const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: '100%',
        width: '100%',
        position: 'relative',
    }
}))
const initialModalState = {
    open: false,
    record: null,
    index: null,
}
const Classifications = ({classifications, dataSource, setValue, removeGroup}) => {
    const classes = useStyles();
    const [classificationsModalState, setClassificationsModalState] = useState(initialModalState)

    function saveClassification(value) {
        setValue(value, `${dataSource}.classification.${classificationsModalState.index}`)
    }

    return (
        <>
            <div>
                <Typography variant={"subtitle2"} style={{paddingTop: 5}}>Classifications</Typography>
                <div className={classes.container}>
                    <div style={{
                        width: '100%',
                        display: "flex",
                        background: 'rgba(0,0,0,0.04)',
                        padding: 10,
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                        marginTop: 10
                    }}>
                        <div style={{width: '22%'}}>
                            <Typography variant={"subtitle2"} style={{fontWeight: 600}}>From</Typography>
                        </div>
                        <div style={{width: '22%'}}>
                            <Typography variant={"subtitle2"} style={{fontWeight: 600}}>To</Typography>
                        </div>
                        <div style={{width: '22%'}}>
                            <Typography variant={"subtitle2"} style={{fontWeight: 600}}>Name</Typography>
                        </div>
                        <div style={{width: '22%'}}>
                            <Typography variant={"subtitle2"} style={{fontWeight: 600}}>Color</Typography>
                        </div>
                        <div style={{
                            padding: "10px 22px",
                            visibility: 'hidden'
                        }}>
                            a
                        </div>
                    </div>

                    <div style={{width:'100%'}}>
                        {classifications?.map((classification, index) => (
                            <ClassificationItem
                                classification={classification}
                                index={index}
                                key={index}
                                setClassificationModalState={setClassificationsModalState}
                                dataSource={dataSource}
                                removeGroup={removeGroup}
                            />
                        ))}
                    </div>

                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                        alignItems: "center"
                    }}>
                        {!classifications || !classifications.length && (
                            <Typography
                                variant={"subtitle2"}
                                color={"textSecondary"}
                                style={{padding: "15px 0 5px 0"}}
                            >
                                No classifications found
                            </Typography>
                        )}
                        <IconButton
                            size={"small"}
                            style={{marginTop: 5}}
                            onClick={() => {
                                setClassificationsModalState({
                                    open: true,
                                    index: classifications.length || 0,
                                })
                            }}>
                            <Icon fontSize="small">
                                add
                            </Icon>
                        </IconButton>
                    </div>

                </div>
            </div>
            <ClassificationModal
                open={classificationsModalState.open}
                record={classificationsModalState.record}
                path={classificationsModalState.path}
                saveClassification={saveClassification}
                onClose={() => setClassificationsModalState(initialModalState)}
            />
        </>
    )
}

export default JsonScreenHoc(Classifications);

Classifications.propTypes = {
    classifications: PropTypes.array
}